import { UseQueryOptions, useQuery } from 'react-query';
import { DefaultGetResponse } from '~/App/Api/rest';
import { InvoiceInformation } from '~/types/models';
import axios, { AxiosError } from 'axios';
import { billingApi } from '../utils';

export const queryKeys = {
  detail: ['invoice-information', 'detail'] as const,
};

export async function getInvoiceInfo() {
  const res = await axios.get<InvoiceInformation>(`${billingApi}/invoice-info`);
  return res.data;
}

export interface UseInvoiceInfoParams {
  options?: UseQueryOptions<DefaultGetResponse<InvoiceInformation>, AxiosError>;
}

export const useInvoiceInfo = ({ options }: UseInvoiceInfoParams) =>
  useQuery<DefaultGetResponse<InvoiceInformation>, AxiosError>(
    queryKeys.detail,
    getInvoiceInfo,
    options
  );
